<template>
  <div class="flex h-32 justify-center items-center">
    <SpinnerIcon class="h-6 w-6 animate-spin mr-1" />
    <slot>
      <p class="text-muted-foreground">
        {{ $t('Loading') }}
      </p>
    </slot>
  </div>
</template>
<script setup lang="ts">
import SpinnerIcon from './icons/SpinnerIcon.vue'

</script>